import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "phaseTaskPaymentApprovalModal",
  tabindex: "-1",
  "aria-labelledby": "addModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "alert alert-success text-center mb-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "bg-light p-3" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_15 = { class: "mt-2" }
const _hoisted_16 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_17 = {
  class: "custom-control-label",
  for: "percentage"
}
const _hoisted_18 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_19 = {
  class: "custom-control-label",
  for: "partial"
}
const _hoisted_20 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_21 = {
  class: "custom-control-label",
  for: "full"
}
const _hoisted_22 = { class: "dispatch-total-amount-wrap" }
const _hoisted_23 = {
  key: 0,
  class: "form-group"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "alert alert-success text-center" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { for: "exampleInputEmail1" }
const _hoisted_29 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_ToDoPhasePaymentHistory = _resolveComponent("ToDoPhasePaymentHistory")
  const _component_Button = _resolveComponent("Button")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t('payment_approval')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTaskLogModal && _ctx.hideTaskLogModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_7
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.createPhase,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", null, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    (_ctx.state.data.phaseBudget)
                      ? (_openBlock(), _createBlock("strong", _hoisted_11, _toDisplayString(_ctx.$t('phase_estimated_budget')) + " : $ " + _toDisplayString(_ctx.state.data.phaseBudget), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (
                    _ctx.state.data.paymentHistory.payerPaymentRequests &&
                    _ctx.state.data.paymentHistory.payerPaymentRequests.length
                  )
                    ? (_openBlock(), _createBlock(_component_ToDoPhasePaymentHistory, {
                        key: 0,
                        payerContractor: true,
                        history: _ctx.state.data.paymentHistory.payerPaymentRequests
                      }, null, 8, ["history"]))
                    : _createCommentVNode("", true),
                  (
                    _ctx.state.data.paymentHistory.contractorPaymentRequests &&
                    _ctx.state.data.paymentHistory.contractorPaymentRequests.length
                  )
                    ? (_openBlock(), _createBlock(_component_ToDoPhasePaymentHistory, {
                        key: 1,
                        payerContractor: false,
                        history: _ctx.state.data.paymentHistory.contractorPaymentRequests
                      }, null, 8, ["history"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t('please_select_your_preferred_payment')) + " :", 1),
                    _hoisted_14,
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _withDirectives(_createVNode("input", {
                          class: "custom-control-input",
                          type: "radio",
                          id: "percentage",
                          name: "fav_language",
                          value: "2",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.paymentType = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.state.data.paymentType]
                        ]),
                        _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('percentage')), 1)
                      ]),
                      _createVNode("div", _hoisted_18, [
                        _withDirectives(_createVNode("input", {
                          class: "custom-control-input",
                          type: "radio",
                          id: "partial",
                          name: "fav_language",
                          value: "1",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.paymentType = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.state.data.paymentType]
                        ]),
                        _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('partial')), 1)
                      ]),
                      _createVNode("div", _hoisted_20, [
                        _withDirectives(_createVNode("input", {
                          class: "custom-control-input",
                          type: "radio",
                          id: "full",
                          name: "fav_language",
                          value: "3",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.paymentType = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.state.data.paymentType]
                        ]),
                        _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('full')), 1)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_22, [
                    (
                      _ctx.state.data.paymentType === '2' ||
                      _ctx.state.data.paymentType === '1'
                    )
                      ? (_openBlock(), _createBlock("div", _hoisted_23, [
                          (_ctx.state.data.paymentType === '2')
                            ? (_openBlock(), _createBlock("label", _hoisted_24, _toDisplayString(_ctx.$t('percentage')), 1))
                            : (_ctx.state.data.paymentType === '1')
                              ? (_openBlock(), _createBlock("label", _hoisted_25, "Partial"))
                              : _createCommentVNode("", true),
                          _withDirectives(_createVNode("input", {
                            class: "form-control",
                            name: "percentage_number",
                            id: "number",
                            type: "number",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.percentage = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.percentage]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_26, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('dispatched_amount')) + " :", 1),
                      _createTextVNode(" $ " + _toDisplayString(_ctx.dispatchedAmount), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('remarks')), 1),
                    _withDirectives(_createVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "exampleInputEmail1",
                      "aria-describedby": "emailHelp",
                      placeholder: _ctx.$t('add_remarks_if_needed'),
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.remarkDetails = $event))
                    }, null, 8, ["placeholder"]), [
                      [_vModelText, _ctx.state.data.remarkDetails]
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode(_component_Button, {
                disabled: _ctx.dispatchedAmount === 0,
                buttonName: _ctx.state.data.buttonName,
                buttonLoading: _ctx.state.ui.isPostLoading.createPhase,
                onButtonTrigger: _cache[7] || (_cache[7] = ($event: any) => (_ctx.paymentReleaseByPhase(1)))
              }, null, 8, ["disabled", "buttonName", "buttonLoading"]),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.paymentReleaseByPhase(2)))
              }, _toDisplayString(_ctx.$t('decline')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}